import PreviewTable from 'app/features/questionnaires/components/PreviewTable';
import { useSelector } from 'react-redux';
import { fields } from './fields';
import {
  selectRentalActivity,
} from './slice';


export interface IRentalActivityProps {}

export default function RentalActivity(
  props: IRentalActivityProps ,
) {
    const fieldsState = useSelector( selectRentalActivity);

    return (
        <PreviewTable
          fields={fields}
          fieldsState={fieldsState}
          sectionName="RentalActivity"
        />
      );
    }
    